import { ContentPosition } from './ui-view.model';

export interface IClientInfoResponse {
  success: boolean;
  error?: any;
  status: number;
  data: IClientInfo;
}

export interface ClaimsAddress {
  street_address: any;
  pincode: any;
  country: any;
  area: any;
  region: any;
  formatted: any;
}

export interface IClientInfo {
  logo_uri?: string;
  fav_icon_uri?: string | undefined;
  login_providers?: string[];
  custom_providers?: IProviderMetadData[];
  saml_providers?: IProviderMetadData[];
  ad_providers?: IProviderMetadData[];
  passwordless_enabled?: boolean;
  imprint_uri?: string;
  policy_uri?: string;
  tos_uri?: string;
  copy_right_info?: string;
  client_name?: string;
  client_display_name?: string;
  captcha_site_key?: string;
  allow_login_with?: string[];
  fds_enabled?: boolean;
  registration_enabled?: boolean;

  allowed_mfa?: string[];
  password_policy?: IPasswordPolicySetup;
  consentDetails?: IConsentVersion;

  email_verification_required?: boolean;
  mobile_number_verification_required?: boolean;
  allowed_login_providers?: boolean;
  is_remember_me_selected?: boolean;
  primaryColor?: string;
  accentColor?: string;
  backgroundUri?: string;
  allow_guest_login?: boolean;
  contentAlign?: string;
  logoAlign?: string;
  mediaType?: string;
  videoUrl?: string;
  error_page_uri?: string;
  invite_enabled?: boolean;

  webfinger?: WebFinger;
}

export type WebFinger = 'no_redirection' | 'user_and_domain_based_redirection' | 'domain_based_redirection';


export interface IProviderMetadData {
  logo_url: string;
  provider_name: string;
  display_name: string;
  type: string;
}

export interface IPasswordPolicySetup {
  _id: string;
  id: string;
  policy_name: string;
  minimumLength: number;
  maximumLength: number;
  noOfSpecialChars: number;
  noOfDigits: number;
  lowerAndUpperCase: boolean;
  validityDays: number;
  notifyUserBefore: number;
  preventAlreadyUsedPwd: boolean;
  preventPersonalInformation: boolean;
}

export interface IConsentVersion {
  _id?: string;
  id?: string;
  version?: number;
  scopes?: string[];
  customField?: string;
  consentType?: string;
  consent_locale?: IConsentLocale;
  consent_locales?: IConsentLocale[];
}

export interface IConsentLocale {
  _id?: string;
  id?: string;
  title?: string;
  url?: string;
  content?: string;
  content_agrement_text?: string;
  locale?: string;
  consent_id?: string;
  consent_version_id?: string;
}

export interface IGroupClientInfoResponse{
  id: any;
  meta_data: ILoginMetadata;
  validation_type: string;
}

export interface ILoginGroupData {
  id: any;
  meta_data: ILoginMetadata;
}

export interface IGroupScopeInput {
  track_id: string;
  locale: string;
  requestId: string;
}

export interface ISelGroupMetadata{
  groupId?: string;
  groupName?: string;
  logoURL?: string;
}

export interface ILoginMetadata {
  amr_values?: string[];
  selectableGroups: ISelGroupMetadata[];
}
export interface IClientInfoRequest {
  requestId: string;
}

export const mapAlignmentToContentPosition = (position: string): ContentPosition | undefined => {
  switch (position) {
    case 'LEFT':
      return ContentPosition.Left;
    case 'CENTER':
      return ContentPosition.Center;
    case 'RIGHT':
      return ContentPosition.Right;
    default:
      return undefined;
  }
};

